<template>
  <div >
    <b-container fluid class="md-content">
        <div class="md-header">Plan Typen Muster</div>
        <b-card>
            <b-row>
                <b-col>
                    <b-button variant="success" @click="showModal('modal-createtemplate')">Muster anlegen</b-button>
                </b-col>
                
                <b-col>
                    <b-button variant="primary" @click="refresh()">Aktualisieren</b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-if="templates != undefined">
                <b-col>
                    <b-table striped hover :borderless="true" :outlined="false" :items="templates" :fields="fields">
                        
                        <template slot="actions" slot-scope="row">
                            <b-button class="mx-1" size="sm" v-on:click="openViewModal(row.item.id)"><i class="fas fa-eye"></i></b-button>
                            <b-button class="mx-1" size="sm" v-on:click="openEditModal(row)"><i class="fas fa-pencil-alt"></i></b-button>
                            <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteModal(row)"><i class="fas fa-trash"></i></b-button>
                        </template>
                        
                    </b-table>
                </b-col>
            </b-row>
        </b-card>
    </b-container>

    <b-modal ref="modal-createtemplate"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Plan Typ  Muster anlegen" @cancel="hideModal('modal-createtemplate')" @ok="createEmployeeTypeTemplate" cancel-title="Abbrechen">
        <b-container fluid>
            <div>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="KV Vorlage" label-for="ctfield0">
                    <b-form-select id = "cegfield1" v-model="employeeTypeTemplate.contractId" @change="onChangeContract">
                        <option v-bind:key ="1" v-bind:value="null">
                            Kein KV
                        </option>
                        <option v-for="option in collectiveContractMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Name" label-for="ctfield1">
                    <b-form-input  min="0" id="ctfield1" v-model="employeeTypeTemplate.name" type="text"></b-form-input>
                </b-form-group>

                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Monats Soll-Stunden Min." label-for="ctfield2" :description="''+employeeTypeTemplate.monthTimeRegularMin">
                    <b-form-input :disabled="templateLimits.disableMonthTimeRegular" :min="templateLimits.monthTimeRegularMinLimit" :max="employeeTypeTemplate.monthTimeRegularMax" id="ctfield2" v-model.number="employeeTypeTemplate.monthTimeRegularMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Monats Soll-Stunden Max." label-for="ctfield3" :description="''+employeeTypeTemplate.monthTimeRegularMax">
                    <b-form-input :disabled="templateLimits.disableMonthTimeRegular" :min="employeeTypeTemplate.monthTimeRegularMin"  :max="templateLimits.monthTimeRegularMaxLimit" id="ctfield3" v-model.number="employeeTypeTemplate.monthTimeRegularMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Monats-Soll Typ" label-for="ctfield4">
                    <b-form-select :disabled="templateLimits.disableMonthTimeMaxType" id = "ctfield4" v-model.number="employeeTypeTemplate.monthTimeMaxType">
                        <option value="1">Monats Sollstunden dürfen bei der Planung beliebig überschritten werden</option>
                        <option value="2">Monats Sollstunden dürfen bei der Planung max. um einen festen Betrag überschritten werden</option>
                        <option value="3">Monats Sollstunden dürfen bei der Planung nicht überschritten werden</option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Monats-Soll Buffer Min." label-for="ctfield5" v-if="employeeTypeTemplate.monthTimeMaxType===2" :description="''+employeeTypeTemplate.monthTimeAdjustmentMin">
                    <b-form-input :disabled="templateLimits.disableMonthTimeMaxAdjustment" :min="templateLimits.monthTimeMaxAdjustmentMinLimit" :max="employeeTypeTemplate.monthTimeMaxAdjustmentMax" id="ctfield5" v-model.number="employeeTypeTemplate.monthTimeMaxAdjustmentMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Monats-Soll Buffer Max." label-for="ctfield6" v-if="employeeTypeTemplate.monthTimeMaxType===2" :description="''+employeeTypeTemplate.monthTimeAdustmentMax">
                    <b-form-input :disabled="templateLimits.disableMonthTimeMaxAdjustment" :min="employeeTypeTemplate.monthTimeAdjustmentMin" :max="templateLimits.monthTimeMaxAdjustmentMaxLimit" id="ctfield6" v-model.number="employeeTypeTemplate.monthTimeMaxAdjustmentMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen Soll-Stunden Min." label-for="ctfield7" :description="''+employeeTypeTemplate.weekTimeRegularMin">
                    <b-form-input :disabled="templateLimits.disableWeekTimeRegular" :min="templateLimits.weekTimeRegularMinLimit" :max="employeeTypeTemplate.weekTimeRegularMax" id="ctfield7" v-model.number="employeeTypeTemplate.weekTimeRegularMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen Soll-Stunden Max." label-for="ctfield8" :description="''+employeeTypeTemplate.weekTimeRegularMax">
                    <b-form-input :disabled="templateLimits.disableWeekTimeRegular" :min="employeeTypeTemplate.weekTimeRegularMin" :max="templateLimits.weekTimeRegularMaxLimit" id="ctfield8" v-model.number="employeeTypeTemplate.weekTimeRegularMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen Max-Stunden Min." label-for="ctfield9" :description="''+employeeTypeTemplate.weekTimeMaxMin">
                    <b-form-input :disabled="templateLimits.disableWeekTimeMax" :min="templateLimits.weekTimeMaxMinLimit" id="ctfield9" :max="employeeTypeTemplate.weekTimeMaxMax" v-model.number="employeeTypeTemplate.weekTimeMaxMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen Max-Stunden Max." label-for="ctfield10" :description="''+employeeTypeTemplate.weekTimeMaxMax">
                    <b-form-input :disabled="templateLimits.disableWeekTimeMax" :min="employeeTypeTemplate.weekTimeMaxMin" :max="templateLimits.weekTimeMaxMaxLimit" id="ctfield10" v-model.number="employeeTypeTemplate.weekTimeMaxMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen-Durchnitt Typ" label-for="ctfield4b">
                    <b-form-select :disabled="templateLimits.disableWeekTimeAvgType" id = "ctfield4b" v-model.number="employeeTypeTemplate.weekTimeAvgType">
                        <option value="1">Wochen Durchschnitt Sollstunden können bei der Planung ignoriert werden</option>
                        <option value="2">Wochen Durchschnitt Sollstunden sollen möglichst nah an den Wochen Sollstunden liegen</option>
                        <option value="3">Wochen Durchschnitt Sollstunden dürfen Wochen Sollstunden nicht überschreiten</option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen Soll-Arbeitstage Min." label-for="ctfield11" :description="''+employeeTypeTemplate.weekWorkDaysRegularMin">
                    <b-form-input :disabled="templateLimits.disableWeekWorkDaysRegular" :min="templateLimits.weekWorkDaysRegularMinLimit" :max="employeeTypeTemplate.weekWorkDaysRegularMax" id="ctfield11" v-model.number="employeeTypeTemplate.weekWorkDaysRegularMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen Soll-Arbeitstage Max." label-for="ctfield12" :description="''+employeeTypeTemplate.weekWorkDaysRegularMax">
                    <b-form-input :disabled="templateLimits.disableWeekWorkDaysRegular" :min="employeeTypeTemplate.weekWorkDaysRegularMin" :max="templateLimits.weekWorkDaysRegularMaxLimit" id="ctfield12" v-model.number="employeeTypeTemplate.weekWorkDaysRegularMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Tages Soll-Stunden Min." label-for="ctfield13" :description="''+employeeTypeTemplate.dayTimeRegularMin">
                    <b-form-input :disabled="templateLimits.disableDayTimeRegular" :min="templateLimits.dayTimeRegularMinLimit" :max="employeeTypeTemplate.dayTimeRegularMax" id="ctfield13" v-model.number="employeeTypeTemplate.dayTimeRegularMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Tages Soll-Stunden Max." label-for="ctfield14" :description="''+employeeTypeTemplate.dayTimeRegularMax">
                    <b-form-input :disabled="templateLimits.disableDayTimeRegular" :min="employeeTypeTemplate.dayTimeRegularMin" :max="templateLimits.dayTimeRegularMaxLimit" id="ctfield14" v-model.number="employeeTypeTemplate.dayTimeRegularMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Tages Max-Stunden Min." label-for="ctfield15" :description="''+employeeTypeTemplate.dayTimeMaxMin">
                    <b-form-input :disabled="templateLimits.disableDayTimeMax" :min="templateLimits.dayTimeMaxMinLimit" :max="employeeTypeTemplate.dayTimeMaxMax" id="ctfield15" v-model.number="employeeTypeTemplate.dayTimeMaxMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Tages Max-Stunden Max." label-for="ctfield16" :description="''+employeeTypeTemplate.dayTimeMaxMax">
                    <b-form-input :disabled="templateLimits.disableDayTimeMax" :min="employeeTypeTemplate.dayTimeMaxMin" :max="templateLimits.dayTimeMaxMaxLimit" id="ctfield16" v-model.number="employeeTypeTemplate.dayTimeMaxMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Ruhezeit Min." label-for="ctfield17" :description="''+employeeTypeTemplate.restTimeMin">
                    <b-form-input :disabled="templateLimits.disableRestTime" :min="templateLimits.restTimeMinLimit" :max="employeeTypeTemplate.restTimeMax" id="ctfield17" v-model.number="employeeTypeTemplate.restTimeMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Ruhezeit Max." label-for="ctfield18" :description="''+employeeTypeTemplate.restTimeMax">
                    <b-form-input :disabled="templateLimits.disableRestTime" :min="employeeTypeTemplate.restTimeMin" :max="templateLimits.restTimeMaxLimit" id="ctfield18" v-model.number="employeeTypeTemplate.restTimeMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Freizeit / Woche in Tagen Min." label-for="ctfield19" :description="''+employeeTypeTemplate.weekSpareDaysMinMin">
                    <b-form-input :disabled="templateLimits.disableWeekSpareDaysMin" :min="templateLimits.weekSpareDaysMinMinLimit" :max="employeeTypeTemplate.weekSpareDaysMinMax" id="ctfield19" v-model.number="employeeTypeTemplate.weekSpareDaysMinMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Freizeit / Woche in Tagen Max." label-for="ctfield20" :description="''+employeeTypeTemplate.weekSpareDaysMinMax">
                    <b-form-input :disabled="templateLimits.disableWeekSpareDaysMin" :min="employeeTypeTemplate.weekSpareDaysMinMin" :max="templateLimits.weekSpareDaysMinMaxLimit" id="ctfield20" v-model.number="employeeTypeTemplate.weekSpareDaysMinMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Zusätzliche Freizeit in Stunden" label-for="ctfield21" :description="''+employeeTypeTemplate.weekAdditionalSpareTime">
                    <b-form-input :disabled="templateLimits.disableWeekAdditionalSpareTime" :min="templateLimits.weekAdditionalSpareTimeMinLimit" :max="templateLimits.weekAdditionalSpareTimeMaxLimit" id="ctfield21" v-model.number="employeeTypeTemplate.weekAdditionalSpareTime" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Freizeit Beginn Typ" label-for="ctfield38">
                    <b-form-select id = "ctfield38" v-model.number="employeeTypeTemplate.weekSpareTimeStartType">
                        <option value="1">Mindest Wochen Freizeit kann zu jeder Uhrzeit beginnen</option>
                        <option value="2">Mindest Wochen Freizeit soll möglichst nahe an Ziel Uhrzeit beginnen</option>
                        <option value="3">Mindest Wochen Freizeit muss vor Ziel Uhrzeit beginnen</option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Freizeit Ziel Uhrzeit Min." label-for="ctfield39" v-if="employeeTypeTemplate.weekSpareTimeStartType === 2 || employeeTypeTemplate.weekSpareTimeStartType === 3" >
                    <b-form-input id="ctfield39" v-model="employeeTypeTemplate.weekSpareTimeStartMin" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Freizeit Ziel Uhrzeit Max." label-for="ctfield40" v-if="employeeTypeTemplate.weekSpareTimeStartType === 2 || employeeTypeTemplate.weekSpareTimeStartType === 3" >
                    <b-form-input id="ctfield41" v-model="employeeTypeTemplate.weekSpareTimeStartMax" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Mehrere Schichten/Tag" label-for="ctfield22">
                     <b-form-checkbox id="ctfield22" v-model="employeeTypeTemplate.allowMultipleShifts">
                    </b-form-checkbox>
                </b-form-group>

                <section v-if="employeeTypeTemplate.allowMultipleShifts">
                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Min. Zeit zwischen Schicht Min." label-for="ctfield23" :description="''+employeeTypeTemplate.shiftBetweenTimeMinMin">
                        <b-form-input  min="-1" :max="employeeTypeTemplate.shiftBetweenTimeMinMax" id="ctfield23" v-model.number="employeeTypeTemplate.shiftBetweenTimeMinMin" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Min. Zeit zwischen Schicht Max." label-for="ctfield24" :description="''+employeeTypeTemplate.shiftBetweenTimeMinMax">
                        <b-form-input  :min="employeeTypeTemplate.shiftBetweenTimeMinMin" max="24" id="ctfield24" v-model.number="employeeTypeTemplate.shiftBetweenTimeMinMax" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. Zeit zwischen Schicht Min." label-for="ctfield25" :description="''+employeeTypeTemplate.shiftBetweenTimeMaxMin">
                        <b-form-input  min="-1" :max="employeeTypeTemplate.shiftBetweenTimeMaxMax" id="ctfield25" v-model.number="employeeTypeTemplate.shiftBetweenTimeMaxMin" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. Zeit zwischen Schicht Max." label-for="ctfield26" :description="''+employeeTypeTemplate.shiftBetweenTimeMaxMax">
                        <b-form-input  :min="employeeTypeTemplate.shiftBetweenTimeMaxMin" max="24" id="ctfield26" v-model.number="employeeTypeTemplate.shiftBetweenTimeMaxMax" type="range"></b-form-input>
                    </b-form-group>
                </section>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Aufeinander folgende Arbeitstage begrenzen" label-for="ctfield27">
                     <b-form-checkbox id="ctfield27" v-model="employeeTypeTemplate.limitConsecutiveDays">
                    </b-form-checkbox>
                </b-form-group>

                <section v-if="employeeTypeTemplate.limitConsecutiveDays">
                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. aufeinander folgende Arbeitstage Min." label-for="ctfield28" :description="''+employeeTypeTemplate.daysConsecutiveMaxMin">
                        <b-form-input  min="-1" :max="employeeTypeTemplate.daysConsecutiveMaxMax" id="ctfield28" v-model.number="employeeTypeTemplate.daysConsecutiveMaxMin" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. aufeinander folgende Arbeitstage Max." label-for="ctfield29" :description="''+employeeTypeTemplate.daysConsecutiveMaxMax">
                        <b-form-input  :min="employeeTypeTemplate.daysConsecutiveMaxMin" max="31" id="ctfield29" v-model.number="employeeTypeTemplate.daysConsecutiveMaxMax" type="range"></b-form-input>
                    </b-form-group>

                </section>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Überstunden begrenzen" label-for="ctfield30">
                     <b-form-checkbox id="ccfield30" v-model="employeeTypeTemplate.limitOvertime">
                    </b-form-checkbox>
                </b-form-group>

                <section v-if="employeeTypeTemplate.limitOvertime">
                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. Überstunden / Monat Min." label-for="ctfield31" :description="''+employeeTypeTemplate.monthOvertimeMaxMin">
                        <b-form-input  min="-1" :max="employeeTypeTemplate.monthOvertimeMaxMax" id="ctfield31" v-model.number="employeeTypeTemplate.monthOvertimeMaxMin" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. Überstunden / Monat Max." label-for="ctfield32" :description="''+employeeTypeTemplate.monthOvertimeMaxMax">
                        <b-form-input  :min="employeeTypeTemplate.monthOvertimeMaxMin" max="372" id="ctfield32" v-model.number="employeeTypeTemplate.monthOvertimeMaxMax" type="range"></b-form-input>
                    </b-form-group>
                </section>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Arbeitstage / Woche begrenzen " label-for="ctfield33">
                     <b-form-checkbox id="ctfield33" v-model="employeeTypeTemplate.useWorkDaysForSpareTime">
                    </b-form-checkbox>
                </b-form-group>

                <section v-if="employeeTypeTemplate.useWorkDaysForSpareTime">
                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. Arbeitstage/Woche Min." label-for="ctfield34" :description="''+employeeTypeTemplate.weekWorkDaysMaxMin">
                        <b-form-input  min="-1" :max="employeeTypeTemplate.weekWorkDaysMaxMax" id="ctfield34" v-model.number="employeeTypeTemplate.weekWorkDaysMaxMin" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. Arbeitstage/Woche Max." label-for="ctfield35" :description="''+employeeTypeTemplate.weekWorkDaysMaxMax">
                        <b-form-input  :min="employeeTypeTemplate.weekWorkDaysMaxMin" max="7" id="ctfield35" v-model.number="employeeTypeTemplate.weekWorkDaysMaxMax" type="range"></b-form-input>
                    </b-form-group>
                </section>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Mitarbeiter Anzahl limitieren" label-for="ctfield36">
                     <b-form-checkbox id="ctfield36" v-model="employeeTypeTemplate.limitEmployeeCount">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group v-if="employeeTypeTemplate.limitEmployeeCount" label-text-align="left" label-cols="4" label-cols-lg="4" label="Mitarbeiter Anzahl Max." label-for="ctfield37" :description="employeeTypeTemplate.employeeCountMax+' Mitarbeiter'">
                    <b-form-input min="1" max="200" id="ctfield37" v-model.number="employeeTypeTemplate.employeeCountMax" type="range"></b-form-input>
                </b-form-group>

            </div>
           
            <b-row v-if="templateerror">
                Fehler beim Erstellen des Plan Typ Musters.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-edittemplate"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Plan Typ  Muster aktualisieren" @cancel="hideModal('modal-edittemplate')" @ok="editEmployeeTypeTemplate" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Name" label-for="ctfield1">
                    <b-form-input id="ctfield1" v-model="employeeTypeTemplate.name" type="text" ></b-form-input>
                </b-form-group>

                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Monats Soll-Stunden Min." label-for="ctfield2" :description="''+employeeTypeTemplate.monthTimeRegularMin">
                    <b-form-input :disabled="templateLimits.disableMonthTimeRegular" :min="templateLimits.monthTimeRegularMinLimit" :max="employeeTypeTemplate.monthTimeRegularMax" id="ctfield2" v-model.number="employeeTypeTemplate.monthTimeRegularMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Monats Soll-Stunden Max." label-for="ctfield3" :description="''+employeeTypeTemplate.monthTimeRegularMax">
                    <b-form-input :disabled="templateLimits.disableMonthTimeRegular" :min="employeeTypeTemplate.monthTimeRegularMin"  :max="templateLimits.monthTimeRegularMaxLimit" id="ctfield3" v-model.number="employeeTypeTemplate.monthTimeRegularMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Monats-Soll Typ" label-for="ctfield4">
                    <b-form-select :disabled="templateLimits.disableMonthTimeMaxType" id = "ctfield4" v-model.number="employeeTypeTemplate.monthTimeMaxType">
                        <option value="1">Monats Sollstunden dürfen bei der Planung beliebig überschritten werden</option>
                        <option value="2">Monats Sollstunden dürfen bei der Planung max. um einen festen Betrag überschritten werden</option>
                        <option value="3">Monats Sollstunden dürfen bei der Planung nicht überschritten werden</option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Monats-Soll Buffer Min." label-for="ctfield5" v-if="employeeTypeTemplate.monthTimeMaxType===2" :description="''+employeeTypeTemplate.monthTimeAdjustmentMin">
                    <b-form-input :disabled="templateLimits.disableMonthTimeMaxAdjustment" :min="templateLimits.monthTimeMaxAdjustmentMinLimit" :max="employeeTypeTemplate.monthTimeMaxAdjustmentMax" id="ctfield5" v-model.number="employeeTypeTemplate.monthTimeMaxAdjustmentMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Monats-Soll Buffer Max." label-for="ctfield6" v-if="employeeTypeTemplate.monthTimeMaxType===2" :description="''+employeeTypeTemplate.monthTimeAdustmentMax">
                    <b-form-input :disabled="templateLimits.disableMonthTimeMaxAdjustment" :min="employeeTypeTemplate.monthTimeAdjustmentMin" :max="templateLimits.monthTimeMaxAdjustmentMaxLimit" id="ctfield6" v-model.number="employeeTypeTemplate.monthTimeMaxAdjustmentMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen Soll-Stunden Min." label-for="ctfield7" :description="''+employeeTypeTemplate.weekTimeRegularMin">
                    <b-form-input :disabled="templateLimits.disableWeekTimeRegular" :min="templateLimits.weekTimeRegularMinLimit" :max="employeeTypeTemplate.weekTimeRegularMax" id="ctfield7" v-model.number="employeeTypeTemplate.weekTimeRegularMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen Soll-Stunden Max." label-for="ctfield8" :description="''+employeeTypeTemplate.weekTimeRegularMax">
                    <b-form-input :disabled="templateLimits.disableWeekTimeRegular" :min="employeeTypeTemplate.weekTimeRegularMin" :max="templateLimits.weekTimeRegularMaxLimit" id="ctfield8" v-model.number="employeeTypeTemplate.weekTimeRegularMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen Max-Stunden Min." label-for="ctfield9" :description="''+employeeTypeTemplate.weekTimeMaxMin">
                    <b-form-input :disabled="templateLimits.disableWeekTimeMax" :min="templateLimits.weekTimeMaxMinLimit" id="ctfield9" :max="employeeTypeTemplate.weekTimeMaxMax" v-model.number="employeeTypeTemplate.weekTimeMaxMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen Max-Stunden Max." label-for="ctfield10" :description="''+employeeTypeTemplate.weekTimeMaxMax">
                    <b-form-input :disabled="templateLimits.disableWeekTimeMax" :min="employeeTypeTemplate.weekTimeMaxMin" :max="templateLimits.weekTimeMaxMaxLimit" id="ctfield10" v-model.number="employeeTypeTemplate.weekTimeMaxMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen-Durchnitt Typ" label-for="ctfield4b">
                    <b-form-select :disabled="templateLimits.disableWeekTimeAvgType" id = "ctfield4b" v-model.number="employeeTypeTemplate.weekTimeAvgType">
                        <option value="1">Wochen Durchschnitt Sollstunden können bei der Planung ignoriert werden</option>
                        <option value="2">Wochen Durchschnitt Sollstunden sollen möglichst nah an den Wochen Sollstunden liegen</option>
                        <option value="3">Wochen Durchschnitt Sollstunden dürfen Wochen Sollstunden nicht überschreiten</option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen Soll-Arbeitstage Min." label-for="ctfield11" :description="''+employeeTypeTemplate.weekWorkDaysRegularMin">
                    <b-form-input :disabled="templateLimits.disableWeekWorkDaysRegular" :min="templateLimits.weekWorkDaysRegularMinLimit" :max="employeeTypeTemplate.weekWorkDaysRegularMax" id="ctfield11" v-model.number="employeeTypeTemplate.weekWorkDaysRegularMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen Soll-Arbeitstage Max." label-for="ctfield12" :description="''+employeeTypeTemplate.weekWorkDaysRegularMax">
                    <b-form-input :disabled="templateLimits.disableWeekWorkDaysRegular" :min="employeeTypeTemplate.weekWorkDaysRegularMin" :max="templateLimits.weekWorkDaysRegularMaxLimit" id="ctfield12" v-model.number="employeeTypeTemplate.weekWorkDaysRegularMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Tages Soll-Stunden Min." label-for="ctfield13" :description="''+employeeTypeTemplate.dayTimeRegularMin">
                    <b-form-input :disabled="templateLimits.disableDayTimeRegular" :min="templateLimits.dayTimeRegularMinLimit" :max="employeeTypeTemplate.dayTimeRegularMax" id="ctfield13" v-model.number="employeeTypeTemplate.dayTimeRegularMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Tages Soll-Stunden Max." label-for="ctfield14" :description="''+employeeTypeTemplate.dayTimeRegularMax">
                    <b-form-input :disabled="templateLimits.disableDayTimeRegular" :min="employeeTypeTemplate.dayTimeRegularMin" :max="templateLimits.dayTimeRegularMaxLimit" id="ctfield14" v-model.number="employeeTypeTemplate.dayTimeRegularMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Tages Max-Stunden Min." label-for="ctfield15" :description="''+employeeTypeTemplate.dayTimeMaxMin">
                    <b-form-input :disabled="templateLimits.disableDayTimeMax" :min="templateLimits.dayTimeMaxMinLimit" :max="employeeTypeTemplate.dayTimeMaxMax" id="ctfield15" v-model.number="employeeTypeTemplate.dayTimeMaxMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Tages Max-Stunden Max." label-for="ctfield16" :description="''+employeeTypeTemplate.dayTimeMaxMax">
                    <b-form-input :disabled="templateLimits.disableDayTimeMax" :min="employeeTypeTemplate.dayTimeMaxMin" :max="templateLimits.dayTimeMaxMaxLimit" id="ctfield16" v-model.number="employeeTypeTemplate.dayTimeMaxMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Ruhezeit Min." label-for="ctfield17" :description="''+employeeTypeTemplate.restTimeMin">
                    <b-form-input :disabled="templateLimits.disableRestTime" :min="templateLimits.restTimeMinLimit" :max="employeeTypeTemplate.restTimeMax" id="ctfield17" v-model.number="employeeTypeTemplate.restTimeMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Ruhezeit Max." label-for="ctfield18" :description="''+employeeTypeTemplate.restTimeMax">
                    <b-form-input :disabled="templateLimits.disableRestTime" :min="employeeTypeTemplate.restTimeMin" :max="templateLimits.restTimeMaxLimit" id="ctfield18" v-model.number="employeeTypeTemplate.restTimeMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Freizeit / Woche in Tagen Min." label-for="ctfield19" :description="''+employeeTypeTemplate.weekSpareDaysMinMin">
                    <b-form-input :disabled="templateLimits.disableWeekSpareDaysMin" :min="templateLimits.weekSpareDaysMinMinLimit" :max="employeeTypeTemplate.weekSpareDaysMinMax" id="ctfield19" v-model.number="employeeTypeTemplate.weekSpareDaysMinMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Freizeit / Woche in Tagen Max." label-for="ctfield20" :description="''+employeeTypeTemplate.weekSpareDaysMinMax">
                    <b-form-input :disabled="templateLimits.disableWeekSpareDaysMin" :min="employeeTypeTemplate.weekSpareDaysMinMin" :max="templateLimits.weekSpareDaysMinMaxLimit" id="ctfield20" v-model.number="employeeTypeTemplate.weekSpareDaysMinMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Zusätzliche Freizeit in Stunden" label-for="ctfield21" :description="''+employeeTypeTemplate.weekAdditionalSpareTime">
                    <b-form-input :disabled="templateLimits.disableWeekAdditionalSpareTime" :min="templateLimits.weekAdditionalSpareTimeMinLimit" :max="templateLimits.weekAdditionalSpareTimeMaxLimit" id="ctfield21" v-model.number="employeeTypeTemplate.weekAdditionalSpareTime" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Freizeit Beginn Typ" label-for="ctfield38">
                    <b-form-select id = "ctfield38" v-model.number="employeeTypeTemplate.weekSpareTimeStartType">
                        <option value="1">Mindest Wochen Freizeit kann zu jeder Uhrzeit beginnen</option>
                        <option value="2">Mindest Wochen Freizeit soll möglichst nahe an Ziel Uhrzeit beginnen</option>
                        <option value="3">Mindest Wochen Freizeit muss vor Ziel Uhrzeit beginnen</option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Freizeit Ziel Uhrzeit Min." label-for="ctfield39" v-if="employeeTypeTemplate.weekSpareTimeStartType === 2 || employeeTypeTemplate.weekSpareTimeStartType === 3" >
                    <b-form-input id="ctfield39" v-model="employeeTypeTemplate.weekSpareTimeStartMin" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Freizeit Ziel Uhrzeit Max." label-for="ctfield40" v-if="employeeTypeTemplate.weekSpareTimeStartType === 2 || employeeTypeTemplate.weekSpareTimeStartType === 3" >
                    <b-form-input id="ctfield41" v-model="employeeTypeTemplate.weekSpareTimeStartMax" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Mehrere Schichten/Tag" label-for="ctfield22">
                     <b-form-checkbox id="ctfield22" v-model="employeeTypeTemplate.allowMultipleShifts">
                    </b-form-checkbox>
                </b-form-group>

                <section v-if="employeeTypeTemplate.allowMultipleShifts">
                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Min. Zeit zwischen Schicht Min." label-for="ctfield23" :description="''+employeeTypeTemplate.shiftBetweenTimeMinMin">
                        <b-form-input  min="-1" :max="employeeTypeTemplate.shiftBetweenTimeMinMax" id="ctfield23" v-model.number="employeeTypeTemplate.shiftBetweenTimeMinMin" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Min. Zeit zwischen Schicht Max." label-for="ctfield24" :description="''+employeeTypeTemplate.shiftBetweenTimeMinMax">
                        <b-form-input  :min="employeeTypeTemplate.shiftBetweenTimeMinMin" max="24" id="ctfield24" v-model.number="employeeTypeTemplate.shiftBetweenTimeMinMax" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. Zeit zwischen Schicht Min." label-for="ctfield25" :description="''+employeeTypeTemplate.shiftBetweenTimeMaxMin">
                        <b-form-input  min="-1" :max="employeeTypeTemplate.shiftBetweenTimeMaxMax" id="ctfield25" v-model.number="employeeTypeTemplate.shiftBetweenTimeMaxMin" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. Zeit zwischen Schicht Max." label-for="ctfield26" :description="''+employeeTypeTemplate.shiftBetweenTimeMaxMax">
                        <b-form-input  :min="employeeTypeTemplate.shiftBetweenTimeMaxMin" max="24" id="ctfield26" v-model.number="employeeTypeTemplate.shiftBetweenTimeMaxMax" type="range"></b-form-input>
                    </b-form-group>
                </section>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Aufeinander folgende Arbeitstage begrenzen" label-for="ctfield27">
                     <b-form-checkbox id="ctfield27" v-model="employeeTypeTemplate.limitConsecutiveDays">
                    </b-form-checkbox>
                </b-form-group>

                <section v-if="employeeTypeTemplate.limitConsecutiveDays">
                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. aufeinander folgende Arbeitstage Min." label-for="ctfield28" :description="''+employeeTypeTemplate.daysConsecutiveMaxMin">
                        <b-form-input  min="-1" :max="employeeTypeTemplate.daysConsecutiveMaxMax" id="ctfield28" v-model.number="employeeTypeTemplate.daysConsecutiveMaxMin" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. aufeinander folgende Arbeitstage Max." label-for="ctfield29" :description="''+employeeTypeTemplate.daysConsecutiveMaxMax">
                        <b-form-input  :min="employeeTypeTemplate.daysConsecutiveMaxMin" max="31" id="ctfield29" v-model.number="employeeTypeTemplate.daysConsecutiveMaxMax" type="range"></b-form-input>
                    </b-form-group>

                </section>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Überstunden begrenzen" label-for="ctfield30">
                     <b-form-checkbox id="ccfield30" v-model="employeeTypeTemplate.limitOvertime">
                    </b-form-checkbox>
                </b-form-group>

                <section v-if="employeeTypeTemplate.limitOvertime">
                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. Überstunden / Monat Min." label-for="ctfield31" :description="''+employeeTypeTemplate.monthOvertimeMaxMin">
                        <b-form-input  min="-1" :max="employeeTypeTemplate.monthOvertimeMaxMax" id="ctfield31" v-model.number="employeeTypeTemplate.monthOvertimeMaxMin" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. Überstunden / Monat Max." label-for="ctfield32" :description="''+employeeTypeTemplate.monthOvertimeMaxMax">
                        <b-form-input  :min="employeeTypeTemplate.monthOvertimeMaxMin" max="372" id="ctfield32" v-model.number="employeeTypeTemplate.monthOvertimeMaxMax" type="range"></b-form-input>
                    </b-form-group>
                </section>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Arbeitstage / Woche begrenzen " label-for="ctfield33">
                     <b-form-checkbox id="ctfield33" v-model="employeeTypeTemplate.useWorkDaysForSpareTime">
                    </b-form-checkbox>
                </b-form-group>

                <section v-if="employeeTypeTemplate.useWorkDaysForSpareTime">
                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. Arbeitstage/Woche Min." label-for="ctfield34" :description="''+employeeTypeTemplate.weekWorkDaysMaxMin">
                        <b-form-input  min="-1" :max="employeeTypeTemplate.weekWorkDaysMaxMax" id="ctfield34" v-model.number="employeeTypeTemplate.weekWorkDaysMaxMin" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. Arbeitstage/Woche Max." label-for="ctfield35" :description="''+employeeTypeTemplate.weekWorkDaysMaxMax">
                        <b-form-input  :min="employeeTypeTemplate.weekWorkDaysMaxMin" max="7" id="ctfield35" v-model.number="employeeTypeTemplate.weekWorkDaysMaxMax" type="range"></b-form-input>
                    </b-form-group>
                </section>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Mitarbeiter Anzahl limitieren" label-for="ctfield36">
                     <b-form-checkbox id="ctfield36" v-model="employeeTypeTemplate.limitEmployeeCount">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group v-if="employeeTypeTemplate.limitEmployeeCount" label-text-align="left" label-cols="4" label-cols-lg="4" label="Mitarbeiter Anzahl Max." label-for="ctfield37" :description="employeeTypeTemplate.employeeCountMax+' Mitarbeiter'">
                    <b-form-input min="1" max="200" id="ctfield37" v-model.number="employeeTypeTemplate.employeeCountMax" type="range"></b-form-input>
                </b-form-group>

            </div>
           
            <b-row v-if="templateerror">
                Fehler beim Erstellen des Plan Typ Musters.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-deletetemplate"  no-close-on-backdrop no-close-on-esc centered title="Plan Typ  Muster löschen" @cancel="hideModal('modal-deletetemplate')" @ok="deleteEmployeeTypeTemplate" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row>
                <p> Sind Sie sicher dass Sie dieses Plan Typ Muster löschen wollen?</p>
            </b-row>
            <b-row v-if="templateerror">
                Fehler beim Löschen des Musters.
            </b-row>
        </b-container>
    </b-modal>

   <b-modal ref="modal-viewtemplate"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Plan-Typ Muster Detail" @cancel="hideModal('modal-viewtemplate')" @ok="hideModal('modal-viewtemplate')" cancel-title="Abbrechen">
        <b-container fluid>
         <b-card no-body>
            <b-tabs card>   
                <b-tab title="Plan-Typ">
                    <div v-if="templateId != undefined && employeeTypeTemplateMap[templateId] != undefined">
                        <b-row>
                            <b-col class="md-2">
                                <b>Name:</b>
                            </b-col>
                            <b-col>
                                {{employeeTypeTemplateMap[templateId].name}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Monats-Max Typ.:</b>
                            </b-col>
                            <b-col>
                                {{employeeTypeTemplateMap[templateId].monthTimeMaxType}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Monats-Soll Min.:</b>
                            </b-col>
                            <b-col>
                                {{employeeTypeTemplateMap[templateId].monthTimeRegularMin/60}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Monats-Soll Max.:</b>
                            </b-col>
                            <b-col>
                                {{employeeTypeTemplateMap[templateId].monthTimeRegularMax/60}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Wochen-Soll Min.:</b>
                            </b-col>
                            <b-col>
                                {{employeeTypeTemplateMap[templateId].weekTimeRegularMin/60}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Wochen-Soll Max.:</b>
                            </b-col>
                            <b-col>
                               {{employeeTypeTemplateMap[templateId].weekTimeRegularMax/60}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Tages-Soll Min.:</b>
                            </b-col>
                            <b-col>
                                {{employeeTypeTemplateMap[templateId].dayTimeRegularMin/60}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Tages-Soll Max.:</b>
                            </b-col>
                            <b-col>
                                {{employeeTypeTemplateMap[templateId].dayTimeRegularMax/60}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Ruhezeit Min.:</b>
                            </b-col>
                            <b-col>
                               {{employeeTypeTemplateMap[templateId].restTimeMin/60}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Ruhezeit Max.:</b>
                            </b-col>
                            <b-col>
                               {{employeeTypeTemplateMap[templateId].restTimeMax/60}}
                            </b-col>
                        </b-row>
                        
                    </div>
                </b-tab>
                
            </b-tabs>
        </b-card>   
        </b-container>
    </b-modal>

    
  </div> 

</template>

<script>
export default {
  name: 'employeetypetemplateoverview',
  data () {
    return {
      templates: [],
      employeeTypeTemplateMap:{},
      collectiveContractMap: {},
      fields: [{key:"name", label:"Name", thClass: 'documentsTh', tdClass: 'documentsTd'}, {key:"actions",label: "", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: false}],
      templateId:"",
      contractId: null,
      currentTemplateRow: undefined,
      employeeTypeTemplate: {
          name: "",
          contractId: null,
          monthTimeRegularMin: 173,
          monthTimeRegularMax: 173,
          monthTimeMaxType: 1,
          monthTimeMaxAdjustmentMin: 0,
          monthTimeMaxAdjustmentMax: 0,
          weekTimeMaxMin: 60,
          weekTimeMaxMax: 60,
          weekTimeRegularMin: 40,
          weekTimeRegularMax: 40,
          dayTimeMaxMin: 12,
          dayTimeMaxMax: 12,
          dayTimeRegularMin: 8,
          dayTimeRegularMax: 8,
          restTimeMin: 11,
          restTimeMax: 11,
          allowMultipleShifts: false,
          shiftBetweenTimeMinMin: 0,
          shiftBetweenTimeMinMax: 0,
          shiftBetweenTimeMaxMin: 3,
          shiftBetweenTimeMaxMax: 3,
          limitConsecutiveDays: false,
          daysConsecutiveMaxMin: 6,
          daysConsecutiveMaxMax: 6,
          limitOvertime: false,
          monthOvertimeMaxMin: 20,
          monthOvertimeMaxMax: 20,
          overtimeCutoffMin: 480,
          overtimeCutoffMax: 480,
          useWorkDaysForSpareTime: false,
          weekWorkDaysMaxMin: 1,
          weekWorkDaysMaxMax: 1,
          weekWorkDaysRegularMin: 5,
          weekWorkDaysRegularMax: 5,
          weekSpareDaysMinMin: 1,
          weekSpareDaysMinMax: 1,
          weekAdditionalSpareTime: 12,
          weekTimeAvgType: 1,
          weekSpareTimeStartType: 1,
          weekSpareTimeStartMin: null,
          weekSpareTimeStartMax: null,
          limitEmployeeCount: false,
          employeeCountMax: null
      },
      templateLimits: {
          disableMonthTimeMaxType: false,
          monthTimeRegularMinLimit: -1,
          monthTimeRegularMaxLimit: 372,
          disableMonthTimeRegular: false,
          monthTimeMaxAdjustmentMinLimit: -1,
          monthTimeMaxAdjustmentMaxLimit: 372,
          disableMonthTimeMaxAdjustment: false,
          weekTimeRegularMinLimit: -1,
          weekTimeRegularMaxLimit: 168,
          disableWeekTimeRegular: false,
          weekTimeMaxMinLimit: -1,
          weekTimeMaxMaxLimit: 168,
          disableWeekTimeMax: false,
          disableWeekTimeAvgType: false,
          dayTimeRegularMinLimit: -1,
          dayTimeRegularMaxLimit: 24,
          disableDayTimeRegular: false,
          dayTimeMaxMinLimit: -1,
          dayTimeMaxMaxLimit: 24,
          disableDayTimeMax: false,
          weekWorkDaysRegularMinLimit: 1,
          weekWorkDaysRegularMaxLimit: 7,
          disableWeekWorkDaysRegular: false,
          restTimeMinLimit: -1,
          restTimeMaxLimit: 24,
          disableRestTime: false,
          weekSpareDaysMinMinLimit: 0,
          weekSpareDaysMinMaxLimit: 7,
          disableweekSpareDaysMin: false,
          weekAdditionalSpareTimeMinLimit: 0,
          weekAdditionalSpareTimeMaxLimit: 24,
          disableWeekAdditionalSpareTime: false,

      },
      templateerror: false,
    }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
        this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function(){
        let view = this;

        this.loadCollectiveContracts()
        .then(response => {
            view.updateCollectiveContracts(response.data);
            this.loadEmployeeTypeTemplates()
            .then(response => {
                view.updateEmployeeTypeTemplates(response.data);
            }).catch(function (error) {
                console.log(error)
            })
        })
        .catch(function (error) {
            console.log(error)
        })
        
        
    }, 
    onChangeContract: function (val) {
        this.setEmployeeTypeTemplateValues(val);
        this.setContractLimits(val);
        
    },
    setEmployeeTypeTemplateValues: function(val){
        if(val != null && this.collectiveContractMap[val] != null){
            this.employeeTypeTemplate = {
                contractId: val,
                name: this.employeeTypeTemplate.name,
                monthTimeRegularMin: Math.floor(this.collectiveContractMap[val].monthTimeRegular/60),
                monthTimeRegularMax: Math.floor(this.collectiveContractMap[val].monthTimeRegular/60),
                monthTimeMaxType: this.collectiveContractMap[val].monthTimeMaxType,
               
                monthTimeMaxAdjustmentMin: Math.floor(this.collectiveContractMap[val].monthTimeMaxAdjustment/60),
                monthTimeMaxAdjustmentMax: Math.floor(this.collectiveContractMap[val].monthTimeMaxAdjustment/60),
                
                weekTimeMaxMin: Math.floor(this.collectiveContractMap[val].weekTimeMax/60),
                weekTimeMaxMax: Math.floor(this.collectiveContractMap[val].weekTimeMax/60),
                
                weekTimeRegularMin: Math.floor(this.collectiveContractMap[val].weekTimeRegular/60),
                weekTimeRegularMax: Math.floor(this.collectiveContractMap[val].weekTimeRegular/60),
                
                dayTimeMaxMin: Math.floor(this.collectiveContractMap[val].dayTimeMax/60),
                dayTimeMaxMax: Math.floor(this.collectiveContractMap[val].dayTimeMax/60),
                
                dayTimeRegularMin: Math.floor(this.collectiveContractMap[val].dayTimeRegular/60),
                dayTimeRegularMax: Math.floor(this.collectiveContractMap[val].dayTimeRegular/60),

                restTimeMin: Math.floor(this.collectiveContractMap[val].restTime/60),
                restTimeMax: Math.floor(this.collectiveContractMap[val].restTime/60),
                
                weekSpareDaysMinMin: this.collectiveContractMap[val].weekSpareDaysMin,
                weekSpareDaysMinMax: this.collectiveContractMap[val].weekSpareDaysMin,
                weekAdditionalSpareTime: Math.floor(this.collectiveContractMap[val].weekSpareTimeMin/60) - (this.collectiveContractMap[val].weekSpareDaysMin*24),
                weekTimeAvgType: this.collectiveContractMap[val].weekTimeAvgType,
                
                allowMultipleShifts: false,
                shiftBetweenTimeMinMin: 0,
                shiftBetweenTimeMinMax: 0,
                shiftBetweenTimeMaxMin: 3,
                shiftBetweenTimeMaxMax: 3,
                limitConsecutiveDays: false,
                daysConsecutiveMaxMin: 6,
                daysConsecutiveMaxMax: 6,
                limitOvertime: false,
                monthOvertimeMaxMin: 20,
                monthOvertimeMaxMax: 20,
                overtimeCutoffMin: 480,
                overtimeCutoffMax: 480,
                useWorkDaysForSpareTime: false,
                weekWorkDaysMaxMin: 1,
                weekWorkDaysMaxMax: 1,
                weekWorkDaysRegularMin: 5,
                weekWorkDaysRegularMax: 5,
                weekSpareTimeStartType: 1,
                weekSpareTimeStartMin: null,
                weekSpareTimeStartMax: null,
                limitEmployeeCount: false,
                employeeCountMax: null
            };
            
        } else {
            this.resetEmployeeTypeTemplateValues();
        }
    },
    setContractLimits: function(val){
        if(val != null && this.collectiveContractMap[val] != null){
            this.templateLimits = {
                disableMonthTimeMaxType: true,
                monthTimeRegularMinLimit: Math.floor(this.collectiveContractMap[val].monthTimeRegular/60),
                monthTimeRegularMaxLimit: Math.floor(this.collectiveContractMap[val].monthTimeRegular/60),
                disableMonthTimeRegular: true,
                monthTimeMaxAdjustmentMinLimit: Math.floor(this.collectiveContractMap[val].monthTimeMaxAdjustment/60),
                monthTimeMaxAdjustmentMaxLimit: Math.floor(this.collectiveContractMap[val].monthTimeMaxAdjustment/60),
                disableMonthTimeMaxAdjustment: true,
                weekTimeRegularMinLimit: Math.floor(this.collectiveContractMap[val].weekTimeRegular/60),
                weekTimeRegularMaxLimit: Math.floor(this.collectiveContractMap[val].weekTimeRegular/60),
                disableWeekTimeRegular: true,
                weekTimeMaxMinLimit: Math.floor(this.collectiveContractMap[val].weekTimeMax/60),
                weekTimeMaxMaxLimit: Math.floor(this.collectiveContractMap[val].weekTimeMax/60),
                disableWeekTimeMax: true,
                disableWeekTimeAvgType: true,
                dayTimeRegularMinLimit: Math.floor(this.collectiveContractMap[val].dayTimeRegular/60),
                dayTimeRegularMaxLimit: Math.floor(this.collectiveContractMap[val].dayTimeRegular/60),
                disableDayTimeRegular: true,
                dayTimeMaxMinLimit: Math.floor(this.collectiveContractMap[val].dayTimeMax/60),
                dayTimeMaxMaxLimit: Math.floor(this.collectiveContractMap[val].dayTimeMax/60),
                disableDayTimeMax: true,
                weekWorkDaysRegularMinLimit: this.collectiveContractMap[val].weekWorkDaysRegular,
                weekWorkDaysRegularMaxLimit: this.collectiveContractMap[val].weekWorkDaysRegular,
                disableWeekWorkDaysRegular: true,
                restTimeMinLimit: Math.floor(this.collectiveContractMap[val].restTime/60),
                restTimeMaxLimit: Math.floor(this.collectiveContractMap[val].restTime/60),
                disableRestTime: true,
                weekSpareDaysMinMinLimit: this.collectiveContractMap[val].weekSpareDaysMin,
                weekSpareDaysMinMaxLimit: this.collectiveContractMap[val].weekSpareDaysMin,
                disableWeekSpareDaysMin: true,
                weekAdditionalSpareTimeMinLimit: Math.floor(this.collectiveContractMap[val].weekSpareTimeMin/60) - (this.collectiveContractMap[val].weekSpareDaysMin*24),
                weekAdditionalSpareTimeMaxLimit: Math.floor(this.collectiveContractMap[val].weekSpareTimeMin/60) - (this.collectiveContractMap[val].weekSpareDaysMin*24),
                disableWeekAdditionalSpareTime: true,

            };
        } else {
            this.resetEmployeeTypeTemplateLimits();
        }
        
    },
    createEmployeeTypeTemplate: function(evt){
        evt.preventDefault();
        this.templateerror=false;
        let view = this;
        let url = '/api/sec/employeetypetemplate';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeetypetemplate');
        
        let payload = {
          storeId: this.$store.state.storeId,
        }
        
        payload.name = this.employeeTypeTemplate.name;
        payload.contractId = this.employeeTypeTemplate.contractId;
        payload.monthTimeRegularMin = this.employeeTypeTemplate.monthTimeRegularMin*60;
        payload.monthTimeRegularMax = this.employeeTypeTemplate.monthTimeRegularMax*60;

        payload.monthTimeMaxType = this.employeeTypeTemplate.monthTimeMaxType;

        payload.monthTimeMaxAdjustmentMin = this.employeeTypeTemplate.monthTimeMaxAdjustmentMin;
        payload.monthTimeMaxAdjustmentMax = this.employeeTypeTemplate.monthTimeMaxAdjustmentMax;

        payload.weekTimeMaxMin = this.employeeTypeTemplate.weekTimeMaxMin*60;
        payload.weekTimeMaxMax = this.employeeTypeTemplate.weekTimeMaxMax*60;

        payload.weekTimeRegularMin = this.employeeTypeTemplate.weekTimeRegularMin*60;
        payload.weekTimeRegularMax = this.employeeTypeTemplate.weekTimeRegularMax*60;

        payload.dayTimeRegularMin = this.employeeTypeTemplate.dayTimeRegularMin*60;
        payload.dayTimeRegularMax = this.employeeTypeTemplate.dayTimeRegularMax*60;

        payload.dayTimeMaxMin = this.employeeTypeTemplate.dayTimeMaxMin*60;
        payload.dayTimeMaxMax = this.employeeTypeTemplate.dayTimeMaxMax*60;

        payload.restTimeMin = this.employeeTypeTemplate.restTimeMin*60;
        payload.restTimeMax = this.employeeTypeTemplate.restTimeMax*60;

        payload.weekWorkDaysRegularMin = this.employeeTypeTemplate.weekWorkDaysRegularMin;
        payload.weekWorkDaysRegularMax = this.employeeTypeTemplate.weekWorkDaysRegularMax;

        payload.overtimeCutoffMin = this.employeeTypeTemplate.dayTimeRegularMin*60;
        payload.overtimeCutoffMax = this.employeeTypeTemplate.dayTimeRegularMax*60;

        if(this.employeeTypeTemplate.allowMultipleShifts){
            payload.shiftBetweenTimeMinMin = this.employeeTypeTemplate.shiftBetweenTimeMinMin*60;
            payload.shiftBetweenTimeMinMax = this.employeeTypeTemplate.shiftBetweenTimeMinMax*60;

            payload.shiftBetweenTimeMaxMin = this.employeeTypeTemplate.shiftBetweenTimeMaxMin*60;
            payload.shiftBetweenTimeMaxMax = this.employeeTypeTemplate.shiftBetweenTimeMaxMax*60;
        } else {
            payload.shiftBetweenTimeMinMin = -1;
            payload.shiftBetweenTimeMinMax = -1;

            payload.shiftBetweenTimeMaxMin = -1;
            payload.shiftBetweenTimeMaxMax = -1;
        }

        if(this.employeeTypeTemplate.limitConsecutiveDays){
            payload.daysConsecutiveMaxMin = this.employeeTypeTemplate.daysConsecutiveMaxMin;
            payload.daysConsecutiveMaxMax = this.employeeTypeTemplate.daysConsecutiveMaxMax;
        } else {
            payload.daysConsecutiveMaxMin = -1;
            payload.daysConsecutiveMaxMax = -1;
        }

        if(this.employeeTypeTemplate.limitOvertime){
            payload.monthOvertimeMaxMin = this.employeeTypeTemplate.monthOvertimeMaxMin*60;
            payload.monthOvertimeMaxMax = this.employeeTypeTemplate.monthOvertimeMaxMax*60;
        } else {
            payload.monthOvertimeMaxMin = -1;
            payload.monthOvertimeMaxMax = -1;
        }

        if(this.employeeTypeTemplate.useWorkDaysForSpareTime){
            payload.weekWorkDaysMaxMin = this.employeeTypeTemplate.weekWorkDaysMaxMin;
            payload.weekWorkDaysMaxMax = this.employeeTypeTemplate.weekWorkDaysMaxMax;
        } else {
            payload.weekWorkDaysMaxMin = -1;
            payload.weekWorkDaysMaxMax = -1;
        }

        payload.weekSpareDaysMinMin = this.employeeTypeTemplate.weekSpareDaysMinMin;
        payload.weekSpareDaysMinMax = this.employeeTypeTemplate.weekSpareDaysMinMax;

        payload.weekSpareTimeMinMin = this.employeeTypeTemplate.weekSpareDaysMinMin*24*60 + this.employeeTypeTemplate.weekAdditionalSpareTime*60;
        payload.weekSpareTimeMinMax = this.employeeTypeTemplate.weekSpareDaysMinMax*24*60 + this.employeeTypeTemplate.weekAdditionalSpareTime*60;
        payload.weekTimeAvgType = this.employeeTypeTemplate.weekTimeAvgType;
        
        payload.weekSpareTimeStartType = this.employeeTypeTemplate.weekSpareTimeStartType;
        if(payload.weekSpareTimeStartType == 1){
            payload.weekSpareTimeStartMin = null;
            payload.weekSpareTimeStartMax = null;
        } else {
            payload.weekSpareTimeStartMin = this.$helpers.convertDateTimeString(null,this.employeeTypeTemplate.weekSpareTimeStartMin);
            payload.weekSpareTimeStartMax = this.$helpers.convertDateTimeString(null,this.employeeTypeTemplate.weekSpareTimeStartMax);
        }

        if(this.employeeTypeTemplate.limitEmployeeCount){
            payload.employeeCountMax = this.employeeTypeTemplate.employeeCountMax;
        } else {
            payload.employeeCountMax = null;
        }
        
        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            
            view.employeeTypeTemplateMap[response.data.data.id] = response.data.data;
            let templateItem =  {
                id: response.data.data.id,
                name: response.data.data.name
            }
            view.templates.push(templateItem);
            
            view.hideModal('modal-createtemplate');
 
        }).catch(function (error) {
            view.templateerror=true;
            console.log(error)
        })

    },
    
    openEditModal: function(row){
        this.currentTemplateRow = row;
        this.templateId = row.item.id;
        let templateMapItem = this.employeeTypeTemplateMap[this.templateId];
        this.employeeTypeTemplate = {
          name: templateMapItem.name,
          contractId: templateMapItem.contractId,
          monthTimeRegularMin: templateMapItem.monthTimeRegularMin/60,
          monthTimeRegularMax: templateMapItem.monthTimeRegularMax/60,
          monthTimeMaxType: templateMapItem.monthTimeMaxType,
          monthTimeMaxAdjustmentMin: templateMapItem.monthTimeMaxAdjustmentMin/60,
          monthTimeMaxAdjustmentMax: templateMapItem.monthTimeMaxAdjustmentMax/60,
          weekTimeMaxMin: templateMapItem.weekTimeMaxMin/60,
          weekTimeMaxMax: templateMapItem.weekTimeMaxMax/60,
          weekTimeRegularMin: templateMapItem.weekTimeRegularMin/60,
          weekTimeRegularMax: templateMapItem.weekTimeRegularMax/60,
          dayTimeMaxMin: templateMapItem.dayTimeMaxMin/60,
          dayTimeMaxMax: templateMapItem.dayTimeMaxMax/60,
          dayTimeRegularMin: templateMapItem.dayTimeRegularMin/60,
          dayTimeRegularMax: templateMapItem.dayTimeRegularMax/60,
          restTimeMin: templateMapItem.restTimeMin/60,
          restTimeMax: templateMapItem.restTimeMax/60,
          shiftBetweenTimeMinMin: templateMapItem.shiftBetweenTimeMinMin,
          shiftBetweenTimeMinMax: templateMapItem.shiftBetweenTimeMinMax,
          shiftBetweenTimeMaxMin: templateMapItem.shiftBetweenTimeMaxMin,
          shiftBetweenTimeMaxMax: templateMapItem.shiftBetweenTimeMaxMax,
          daysConsecutiveMaxMin: templateMapItem.daysConsecutiveMaxMin,
          daysConsecutiveMaxMax: templateMapItem.daysConsecutiveMaxMax,
          monthOvertimeMaxMin: templateMapItem.monthOvertimeMaxMin,
          monthOvertimeMaxMax: templateMapItem.monthOvertimeMaxMax,
          overtimeCutoffMin: templateMapItem.overtimeCutoffMin,
          overtimeCutoffMax: templateMapItem.overtimeCutoffMax,
          weekWorkDaysMaxMin: templateMapItem.weekWorkDaysMaxMin,
          weekWorkDaysMaxMax: templateMapItem.weekWorkDaysMaxMax,
          weekWorkDaysRegularMin: templateMapItem.weekWorkDaysRegularMin,
          weekWorkDaysRegularMax: templateMapItem.weekWorkDaysRegularMax,
          weekSpareDaysMinMin: templateMapItem.weekSpareDaysMinMin,
          weekSpareDaysMinMax: templateMapItem.weekSpareDaysMinMax,
          weekAdditionalSpareTime: (templateMapItem.weekSpareTimeMinMin/60) - (templateMapItem.weekSpareDaysMinMin*24),
          weekTimeAvgType: templateMapItem.weekTimeAvgType,
          allowMultipleShifts: false,
          limitConsecutiveDays: false,
          limitOvertime: false,
          useWorkDaysForSpareTime: false,
          weekSpareTimeStartType: templateMapItem.weekSpareTimeStartType,
          weekSpareTimeStartMin: this.$helpers.extractTimeString(templateMapItem.weekSpareTimeStartMin),
          weekSpareTimeStartMax: this.$helpers.extractTimeString(templateMapItem.weekSpareTimeStartMax),
          limitEmployeeCount: false,
          employeeCountMax: templateMapItem.employeeCountMax
        }

        if(this.employeeTypeTemplate.employeeCountMax != null){
            this.employeeTypeTemplate.limitEmployeeCount =  true;
        }

        if(this.employeeTypeTemplate.shiftBetweentimeMinMin > -1){
            this.employeeTypeTemplate.shiftBetweenTimeMinMin = this.employeeTypeTemplate.shiftBetweenTimeMinMin/60;
            this.employeeTypeTemplate.shiftBetweenTimeMinMax = this.employeeTypeTemplate.shiftBetweenTimeMinMax/60;
            this.employeeTypeTemplate.shiftBetweenTimeMaxMin = this.employeeTypeTemplate.shiftBetweenTimeMaxMin/60;
            this.employeeTypeTemplate.shiftBetweenTimeMaxMax = this.employeeTypeTemplate.shiftBetweenTimeMaxMax/60;
            this.employeeTypeTemplate.allowMultipleShifts = true;
        } else {
            this.employeeTypeTemplate.allowMultipleShifts = false;
        }

        if(this.employeeTypeTemplate.daysConsecutiveMaxMin > -1){
            this.employeeTypeTemplate.limitConsecutiveDays = true;
        } else {
            this.employeeTypeTemplate.limitConsecutiveDays = false;
        }

        if(this.employeeTypeTemplate.monthOvertimeMaxMin > -1){
            this.employeeTypeTemplate.monthOvertimeMaxMin = this.employeeTypeTemplate.monthOvertimeMaxMin/60;
            this.employeeTypeTemplate.monthOvertimeMaxMax = this.employeeTypeTemplate.monthOvertimeMaxMax/60;
            this.employeeTypeTemplate.limitOvertime = true;
        } else {
            this.employeeTypeTemplate.limitOvertime = false;
        }

        if(this.employeeTypeTemplate.weekWorkDaysMaxMin > -1){
            this.employeeTypeTemplate.useWorkDaysForSpareTime = true;
        } else {
            this.employeeTypeTemplate.useWorkDaysForSpareTime = false;
        }
        this.setContractLimits(this.employeeTypeTemplate.contractId);
        this.showModal('modal-edittemplate');
    },
    editEmployeeTypeTemplate: function(evt){
        evt.preventDefault();
        this.templateerror=false;
        let view = this;
        let url = '/api/sec/employeetypetemplate';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeetypetemplate');
        
        let payload = {
          id: this.templateId,
          updateFields:["name", "monthTimeRegularMin", "monthTimeRegularMax", "monthTimeMaxType", "monthTimeMaxAdjustmentMin", "monthTimeMaxAdjustmentMax",
                        "weekTimeMaxMin", "weekTimeMaxMax", "weekTimeRegularMin", "weekTimeRegularMax", "dayTimeRegularMin", "dayTimeRegularMax",
                        "dayTimeMaxMin", "dayTimeMaxMax", "restTimeMin", "restTimeMax", "weekWorkDaysRegularMin", "weekWorkDaysRegularMax",
                        "overtimeCutoffMin", "overtimeCutoffMax", "shiftBetweenTimeMinMin", "shiftBetweenTimeMinMax", "shiftBetweenTimeMaxMin", "shiftBetweenTimeMaxMax",
                        "daysConsecutiveMaxMin", "daysConsecutiveMaxMax", "monthOvertimeMaxMin", "monthOvertimeMaxMax", "weekWorkDaysMaxMin", "weekWorkDaysMaxMax",
                        "weekSpareDaysMinMin", "weekSpareDaysMinMax", "weekSpareTimeMinMin", "weekSpareTimeMinMax", "weekTimeAvgType",
                        "weekSpareTimeStartType", "weekSpareTimeStartMin", "weekSpareTimeStarMax", "employeeCountMax"]
        }

        payload.name = this.employeeTypeTemplate.name;

        payload.monthTimeRegularMin = this.employeeTypeTemplate.monthTimeRegularMin*60;
        payload.monthTimeRegularMax = this.employeeTypeTemplate.monthTimeRegularMax*60;

        payload.monthTimeMaxType = this.employeeTypeTemplate.monthTimeMaxType;

        payload.monthTimeMaxAdjustmentMin = this.employeeTypeTemplate.monthTimeMaxAdjustmentMin;
        payload.monthTimeMaxAdjustmentMax = this.employeeTypeTemplate.monthTimeMaxAdjustmentMax;

        payload.weekTimeMaxMin = this.employeeTypeTemplate.weekTimeMaxMin*60;
        payload.weekTimeMaxMax = this.employeeTypeTemplate.weekTimeMaxMax*60;

        payload.weekTimeRegularMin = this.employeeTypeTemplate.weekTimeRegularMin*60;
        payload.weekTimeRegularMax = this.employeeTypeTemplate.weekTimeRegularMax*60;

        payload.dayTimeRegularMin = this.employeeTypeTemplate.dayTimeRegularMin*60;
        payload.dayTimeRegularMax = this.employeeTypeTemplate.dayTimeRegularMax*60;

        payload.dayTimeMaxMin = this.employeeTypeTemplate.dayTimeMaxMin*60;
        payload.dayTimeMaxMax = this.employeeTypeTemplate.dayTimeMaxMax*60;

        payload.restTimeMin = this.employeeTypeTemplate.restTimeMin*60;
        payload.restTimeMax = this.employeeTypeTemplate.restTimeMax*60;

        payload.weekWorkDaysRegularMin = this.employeeTypeTemplate.weekWorkDaysRegularMin;
        payload.weekWorkDaysRegularMax = this.employeeTypeTemplate.weekWorkDaysRegularMax;

        payload.overtimeCutoffMin = this.employeeTypeTemplate.dayTimeRegularMin*60;
        payload.overtimeCutoffMax = this.employeeTypeTemplate.dayTimeRegularMax*60;

        if(this.employeeTypeTemplate.allowMultipleShifts){
            payload.shiftBetweenTimeMinMin = this.employeeTypeTemplate.shiftBetweenTimeMinMin*60;
            payload.shiftBetweenTimeMinMax = this.employeeTypeTemplate.shiftBetweenTimeMinMax*60;

            payload.shiftBetweenTimeMaxMin = this.employeeTypeTemplate.shiftBetweenTimeMaxMin*60;
            payload.shiftBetweenTimeMaxMax = this.employeeTypeTemplate.shiftBetweenTimeMaxMax*60;
        } else {
            payload.shiftBetweenTimeMinMin = -1;
            payload.shiftBetweenTimeMinMax = -1;

            payload.shiftBetweenTimeMaxMin = -1;
            payload.shiftBetweenTimeMaxMax = -1;
        }

        if(this.employeeTypeTemplate.limitConsecutiveDays){
            payload.daysConsecutiveMaxMin = this.employeeTypeTemplate.daysConsecutiveMaxMin;
            payload.daysConsecutiveMaxMax = this.employeeTypeTemplate.daysConsecutiveMaxMax;
        } else {
            payload.daysConsecutiveMaxMin = -1;
            payload.daysConsecutiveMaxMax = -1;
        }

        if(this.employeeTypeTemplate.limitOvertime){
            payload.monthOvertimeMaxMin = this.employeeTypeTemplate.monthOvertimeMaxMin*60;
            payload.monthOvertimeMaxMax = this.employeeTypeTemplate.monthOvertimeMaxMax*60;
        } else {
            payload.monthOvertimeMaxMin = -1;
            payload.monthOvertimeMaxMax = -1;
        }

        if(this.employeeTypeTemplate.useWorkDaysForSpareTime){
            payload.weekWorkDaysMaxMin = this.employeeTypeTemplate.weekWorkDaysMaxMin;
            payload.weekWorkDaysMaxMax = this.employeeTypeTemplate.weekWorkDaysMaxMax;
        } else {
            payload.weekWorkDaysMaxMin = -1;
            payload.weekWorkDaysMaxMax = -1;
        }

        payload.weekSpareDaysMinMin = this.employeeTypeTemplate.weekSpareDaysMinMin;
        payload.weekSpareDaysMinMax = this.employeeTypeTemplate.weekSpareDaysMinMax;

        payload.weekSpareTimeMinMin = this.employeeTypeTemplate.weekSpareDaysMinMin*24*60 + this.employeeTypeTemplate.weekAdditionalSpareTime*60;
        payload.weekSpareTimeMinMax = this.employeeTypeTemplate.weekSpareDaysMinMax*24*60 + this.employeeTypeTemplate.weekAdditionalSpareTime*60;

        payload.weekTimeAvgType = this.employeeTypeTemplate.weekTimeAvgType;

        payload.weekSpareTimeStartType = this.employeeTypeTemplate.weekSpareTimeStartType;
        if(payload.weekSpareTimeStartType == 1){
            payload.weekSpareTimeStartMin = null;
            payload.weekSpareTimeStartMax = null;
        } else {
            payload.weekSpareTimeStartMin = this.$helpers.convertDateTimeString(null,this.employeeTypeTemplate.weekSpareTimeStartMin);
            payload.weekSpareTimeStartMax = this.$helpers.convertDateTimeString(null,this.employeeTypeTemplate.weekSpareTimeStartMax);
        }

        if(this.employeeTypeTemplate.limitEmployeeCount){
            payload.employeeCountMax = this.employeeTypeTemplate.employeeCountMax;
        } else {
            payload.employeeCountMax = null;
        }

        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.currentTemplateRow.item.name=payload.name;
            
            let templateMapItem = view.employeeTypeTemplateMap[view.templateId];
            if(templateMapItem != undefined){
                for (let property in payload) {
                    if (payload.hasOwnProperty(property) && templateMapItem.hasOwnProperty(property)) {
                        templateMapItem[property] = payload[property];
                    }
                }
            }
            
            view.hideModal('modal-edittemplate');
            
            
        }).catch(function (error) {
            view.templateerror=true;
            console.log(error)
        })

    },
    
    openDeleteModal: function(row){
        this.currentTemplateRow = row;
        this.templateId = row.item.id;
        this.showModal('modal-deletetemplate');
    },
    deleteEmployeeTypeTemplate: function(evt){
        evt.preventDefault();
        this.templateerror=false;
        let view = this;
        let url = '/api/sec/employeetypetemplate';
        
        url = this.$helpers.appendParam("id", this.templateId, url, '/api/sec/employeetypetemplate');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeetypetemplate');
        
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = view.templates.findIndex(template => template.id === view.templateId)  
            if (~index) {
                view.templates.splice(index, 1);
            } 
            view.deleteEmployeeTypeTemplateFromMap(view.templateId);
            view.templateId = undefined;
            view.hideModal('modal-deletetemplate');
        }).catch(function (error) {
            view.templateerror=true;
            console.log(error)
        })

    },
    deleteEmployeeTypeTemplateFromMap(id){
        delete this.employeeTypeTemplateMap[id]
    },
    openViewModal: function(id){
        let view = this;
        this.templateId = id;
        
        view.showModal('modal-viewtemplate');
    },
    loadEmployeeTypeTemplates : function() {
      
      let url = '/api/sec/employeetypetemplate';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeetypetemplate');
      
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    updateEmployeeTypeTemplates: function(data){
        
        let templateMap = {};
        let templates = [];
        for (let i = 0; i < data.length; i++) {
            templateMap[data[i].id] =data[i];
            let templateItem = {
                id: data[i].id,
                name: data[i].name
            }
            templates.push(templateItem);
        }
        this.employeeTypeTemplateMap = templateMap;
        this.templates = templates;
    },
    loadCollectiveContracts : function() {
      
      let url = '/api/semi/collectivecontract';

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    updateCollectiveContracts: function(data){
        
        let collectiveContractMap = {};
        
        for (let i = 0; i < data.length; i++) {
            collectiveContractMap[data[i].id] =data[i];
            
        }
        this.collectiveContractMap = collectiveContractMap;
    },
    hideModalWithoutReset (ref) {
        this.templateerror=false;
        this.$refs[ref].hide();
    },
    resetEmployeeTypeTemplateLimits() {
        this.templateLimits ={
          disableMonthTimeMaxType: false,
          monthTimeRegularMinLimit: -1,
          monthTimeRegularMaxLimit: 372,
          disableMonthTimeRegular: false,
          monthTimeMaxAdjustmentMinLimit: -1,
          monthTimeMaxAdjustmentMaxLimit: 372,
          disableMonthTimeMaxAdjustment: false,
          weekTimeRegularMinLimit: -1,
          weekTimeRegularMaxLimit: 168,
          disableWeekTimeRegular: false,
          weekTimeMaxMinLimit: -1,
          weekTimeMaxMaxLimit: 168,
          disableWeekTimeMax: false,
          disableWeekTimeAvgType: false,
          dayTimeRegularMinLimit: -1,
          dayTimeRegularMaxLimit: 24,
          disableDayTimeRegular: false,
          dayTimeMaxMinLimit: -1,
          dayTimeMaxMaxLimit: 24,
          disableDayTimeMax: false,
          weekWorkDaysRegularMinLimit: 1,
          weekWorkDaysRegularMaxLimit: 7,
          disableWeekWorkDaysRegular: false,
          restTimeMinLimit: -1,
          restTimeMaxLimit: 24,
          disableRestTime: false,
          weekSpareDaysMinMinLimit: 0,
          weekSpareDaysMinMaxLimit: 7,
          disableweekSpareDaysMin: false,
          weekAdditionalSpareTimeMinLimit: 0,
          weekAdditionalSpareTimeMaxLimit: 24,
          disableWeekAdditionalSpareTime: false,

      };
    },
    resetEmployeeTypeTemplateValues(){
        this.employeeTypeTemplate = {
          name: "",
          contractId: null,
          monthTimeRegularMin: 173,
          monthTimeRegularMax: 173,
          monthTimeMaxType: 1,
          monthTimeMaxAdjustmentMin: 0,
          monthTimeMaxAdjustmentMax: 0,
          weekTimeMaxMin: 60,
          weekTimeMaxMax: 60,
          weekTimeRegularMin: 40,
          weekTimeRegularMax: 40,
          dayTimeMaxMin: 12,
          dayTimeMaxMax: 12,
          dayTimeRegularMin: 8,
          dayTimeRegularMax: 8,
          restTimeMin: 11,
          restTimeMax: 11,
          allowMultipleShifts: false,
          shiftBetweenTimeMinMin: 0,
          shiftBetweenTimeMinMax: 0,
          shiftBetweenTimeMaxMin: 3,
          shiftBetweenTimeMaxMax: 3,
          limitConsecutiveDays: false,
          daysConsecutiveMaxMin: 6,
          daysConsecutiveMaxMax: 6,
          limitOvertime: false,
          monthOvertimeMaxMin: 20,
          monthOvertimeMaxMax: 20,
          overtimeCutoffMin: 480,
          overtimeCutoffMax: 480,
          useWorkDaysForSpareTime: false,
          weekWorkDaysMaxMin: 1,
          weekWorkDaysMaxMax: 1,
          weekWorkDaysRegularMin: 5,
          weekWorkDaysRegularMax: 5,
          weekSpareDaysMinMin: 1,
          weekSpareDaysMinMax: 1,
          weekAdditionalSpareTime: 12,
          weekTimeAvgType: 1,
          weekSpareTimeStartType: 1,
          weekSpareTimeStartMin: null,
          weekSpareTimeStartMax: null,
          limitEmployeeCount: false,
          employeeCountMax: null
      };
      
    },
    
    
    hideModal (ref) {
       
        this.resetEmployeeTypeTemplateValues();
        this.resetEmployeeTypeTemplateLimits();
        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.$refs[ref].show()
    }
  },
  computed: {
   
  },
  watch: { 
    
  }

}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>

</style>
